export default __webpack_public_path__ + "static/media/cookies.0ef0b503.jpg";